<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header header-elements-inline">
            <h5 class="card-title">Manage Users</h5>
            <button type="button" class="btn btn-primary" v-on:click="addUser">
              Add User
            </button>

            <!-- to do: only for tasting - remove after -->
            <!-- <button type="button" class="btn btn-primary" v-on:click="testNotification">
             Send notification
            </button> -->


          </div>
          <div class="card-body">
            <div class="row justify-content-center">
              <div class="col-lg-12 col-sm-12">
                <ag-grid-vue
                  style="width: 100%; height: 100%"
                  class="ag-theme-alpine-dark"
                  :columnDefs="columnDefs"
                  :rowData="rowData"
                  :gridOptions="gridOptions"
                  :defaultColDef="defaultColDef"
                  :frameworkComponents="frameworkComponents"
                  :context="context"
                ></ag-grid-vue>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit User Modal -->
    <modal-wrapper :isOpen="showEditModal">
      <div
        v-if="showEditModal"
        id="editUser"
        class="customModal fade"
        v-bind:class="{ show: showEditModal }"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h6 class="modal-title">Edit User</h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                v-on:click="closeModal()"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Name:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="name"
                  v-model="editUserName"
                  v-on:focusout="isValid($event, editUserName, 'name')"
                />
                <label
                  class="validation-invalid-label"
                  for="basic"
                  v-bind:class="{ hidden: nameValid }"
                >
                  Field cannot be empty
                </label>
              </div>
              <div class="form-group">
                <div class="form-group">
                  <label>Email:</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="email"
                    v-model="editUserEmail"
                    v-on:focusout="isValid($event, editUserEmail, 'email')"
                    v-bind:class="{ errorField: emailValid == false }"
                  />
                  <label
                    class="validation-invalid-label"
                    for="basic"
                    v-bind:class="{ hidden: emailValid }"
                  >
                    {{ userEmailErrorMessage }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Employee Type:</label>
                <v-select
                  :options="types"
                  label="name"
                  v-model="editUserType"
                ></v-select>
              </div>
              <div class="form-group">
                <label>Employee Category:</label>
                <v-select
                  :options="employeeCategories"
                  label="name"
                  v-model="editUserCategory"
                  :value="editUserCategory"
                  multiple
                  class="dark_text"
                ></v-select>
              </div>
              <div class="form-group">
                <label>User Access Level:</label>
                <v-select
                  :options="accessLevels"
                  label="name"
                  v-model="editUserAccessLevel"
                ></v-select>
              </div>
              <div class="form-group">
                <label>Vacation:</label>
                <v-select
                  :options="vacationTypes"
                  label="name"
                  v-model="editUserVacationType"
                ></v-select>
              </div>
              <div v-if="showEditAlert">
                <span id="span_editUser_alertDetail">
                  {{ editUserMessage }}
                </span>
              </div>
              <div class="form-group">
                <label>Averaging Agreement: (Optional)</label>
                <v-select
                  :options="agreementOptions"
                  label="name"
                  v-model="editUserAveragingAgreement"
                ></v-select>
              </div>
              <div class="form-group">
                <label>Notification hours:</label>
                <el-tooltip class="item ml-2" effect="dark" placement="top">
                  <div slot="content">
                    Number of hours after which the logout notification should
                    be sent
                  </div>
                  <i class="el-icon-info mr-2"></i>
                </el-tooltip>
                <input
                  type="text"
                  class="form-control"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  v-model="editUserNotificationHours"
                  @input="validateHoursInput"
                  v-on:focusout="isValid($event, editUserNotificationHours, 'notificationHours')"
                />
                <label
                  class="validation-invalid-label"
                  for="basic"
                  v-bind:class="{ hidden: notificationHoursValid }"
                >
                  {{ notificationHoursMessage }}
                </label>
              </div>
              <div class="form-group">
                <label>Phone numbers:</label>
                <el-tooltip class="item ml-2" effect="dark" placement="top">
                  <div slot="content">
                    Enter a 10-digit telephone number. Notifications will be
                    sent to these numbers if the user has not logged out.
                  </div>
                  <i class="el-icon-info mr-2"></i>
                </el-tooltip>
                <div v-for="(phone, index) in editPhoneNumbers" :key="index">
                  <div>
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control w-25"
                        inputmode="numeric"
                        pattern="\d{10}"
                        v-model="editPhoneNumbers[index]"
                        @blur="validatePhoneNumber('edit', index)"
                      />
                      <button
                      v-if="index!== 0"
                      @click="removePhoneNumber('edit', index)"
                      class="btn btn-primary phone-input-btn"
                    >
                      <i class="icon-bin2"></i>
                    </button>
                      <label
                      v-if="phoneErrors[index]"
                      class="validation-invalid-label ml-2"
                      for="basic"
                    >
                      {{ phoneErrors[index] }}
                    </label>
                    </div>
                    
                      
                  <div class="d-flex mt-1 justify-content-center w-25">
                      <button
                        v-if="
                          editPhoneNumbers[index] &&
                          editPhoneNumbers[index].length === 10 &&
                          editPhoneNumbers.length === index+1
                        "
                        class="btn btn-primary phone-input-btn"
                        @click="()=>{editPhoneNumbers.push('')}"
                      >
                        <i class="icon-plus3"></i>
                      </button>
                    </div>
                </div>
              </div>
                
                

                
              </div>
              <div v-show="companySettings.isaacIntegration" class="form-group">
                <label>Isaac Driver Number:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Isaac Driver Number"
                  v-model="editUserIsaac"
                  v-on:focusout="isValid($event, editUserIsaac, 'isaacNum')"
                />
                <label
                  class="validation-invalid-label"
                  for="basic"
                  v-bind:class="{ hidden: isaacValid }"
                >
                  {{ isaacValidMessage }}
                </label>
              </div>
              <div>
                <div
                  class="form-group "
                  v-if="this.$store.state.companyFiveOfNine === 'Yes'"
                >
                  <label>5 of 9 employee:</label>
                  <div class="d-flex">
                    <el-tooltip
                      content="All employees are set as 5 of 9 employees per the organization settings"
                      placement="bottom"
                    >
                      <el-switch
                        :value="true"
                        active-color="#13ce66"
                        :disabled="true"
                      ></el-switch>
                    </el-tooltip>
                  </div>
                </div>
                <div v-else class="form-group d-flex flex-column">
                  <label>5 of 9 employee:</label>
                  <el-switch
                    style="display: block"
                    v-model="editUserFiveOfNine"
                    active-color="#13ce66"
                    inactive-color="#ad466c"
                    :active-value="true"
                  ></el-switch>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link"
                data-dismiss="modal"
                v-on:click="closeModal()"
              >
                Close
              </button>
              <button
                type="button"
                class="btn bg-primary"
                v-on:click="submitUserEdit()"
              >
                <spring-spinner
                  :animation-duration="3000"
                  :size="15"
                  color="white"
                  v-if="addUser_loading"
                />
                <div v-else>Save Changes</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal-wrapper>
    <!-- /Edit User Modal -->
    <!-- Add User Modal -->
    <modal-wrapper :isOpen="showAddUserModal">
      <div
        v-if="showAddUserModal"
        class="customModal fade"
        v-bind:class="{ show: showAddUserModal }"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h6 class="modal-title">Add User</h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                v-on:click="closeModal()"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Name:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="name"
                  v-model="addUserName"
                  v-on:focusout="isValid($event, addUserName, 'name')"
                />
                <label
                  class="validation-invalid-label"
                  for="basic"
                  v-bind:class="{ hidden: nameValid }"
                >
                  Field cannot be empty
                </label>
              </div>
              <div class="form-group">
                <div class="form-group">
                  <label>Email:</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="email"
                    v-model="addUserEmail"
                    v-on:focusout="isValid($event, addUserEmail, 'email')"
                    v-bind:class="{ errorField: emailValid == false }"
                  />
                  <label
                    class="validation-invalid-label"
                    for="basic"
                    v-bind:class="{ hidden: emailValid }"
                  >
                    {{ userEmailErrorMessage }}
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Employee Type:</label>
                <v-select
                  :options="types"
                  label="name"
                  v-model="addUserType"
                ></v-select>
              </div>
              <div class="form-group">
                <label>Employee Category:</label>
                <v-select
                  :options="employeeCategories"
                  label="name"
                  v-model="addUserCategory"
                  :value="addUserCategory"
                  multiple
                  class="dark_text"
                ></v-select>
              </div>
              <div class="form-group">
                <label>User Access Level:</label>
                <v-select
                  :options="accessLevels"
                  label="name"
                  v-model="addUserAccessLevel"
                ></v-select>
              </div>
              <div class="form-group">
                <label>Vacation:</label>
                <v-select
                  :options="vacationTypes"
                  label="name"
                  v-model="addUserVacationType"
                ></v-select>
              </div>
              <div v-if="showAddUserAlert">
                <span id="span_addUser_alertDetail">{{ addUserMessage }}</span>
              </div>
              <div class="form-group">
                <label>Averaging Agreement: (Optional)</label>
                <v-select
                  :options="agreementOptions"
                  label="name"
                  v-model="addUserAveragingAgreement"
                ></v-select>
              </div>
              <div class="form-group">
                <label>Notification hours:</label>
                <el-tooltip class="item ml-2" effect="dark" placement="top">
                  <div slot="content">
                    Number of hours after which the logout notification should
                    be sent
                  </div>
                  <i class="el-icon-info mr-2"></i>
                </el-tooltip>
                <input
                  type="text"
                  class="form-control"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  v-model="addUserNotificationHours"
                  @input="validateHoursInput"
                  v-on:focusout="isValid($event, addUserNotificationHours, 'notificationHours')"
                />
                <label
                  class="validation-invalid-label"
                  for="basic"
                  v-bind:class="{ hidden: notificationHoursValid }"
                >
                  {{ notificationHoursMessage }}
                </label>
              </div>
              <div class="form-group">
                <label>Phone numbers:</label>
                <el-tooltip class="item ml-2" effect="dark" placement="top">
                  <div slot="content">
                    Enter a 10-digit telephone number. Notifications will be
                    sent to these numbers if the user has not logged out.
                  </div>
                  <i class="el-icon-info mr-2"></i>
                </el-tooltip>
                <div v-for="(phone, index) in addPhoneNumbers" :key="index">
                  <div>
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control w-25"
                        inputmode="numeric"
                        pattern="\d{10}"
                        v-model="addPhoneNumbers[index]"
                        @blur="validatePhoneNumber('add', index)"
                      />
                      <button
                      v-if="index!== 0"
                      @click="removePhoneNumber('add', index)"
                      class="btn btn-primary phone-input-btn"
                    >
                      <i class="icon-bin2"></i>
                    </button>
                      <label
                      v-if="phoneErrors[index]"
                      class="validation-invalid-label ml-2"
                      for="basic"
                    >
                      {{ phoneErrors[index] }}
                    </label>
                    </div>
                    
                      
                  <div class="d-flex mt-1 justify-content-center w-25">
                      <button
                        v-if="
                          addPhoneNumbers[index] &&
                          addPhoneNumbers[index].length === 10 &&
                          addPhoneNumbers.length === index+1
                        "
                        class="btn btn-primary phone-input-btn"
                        @click="()=>{addPhoneNumbers.push('')}"
                      >
                        <i class="icon-plus3"></i>
                      </button>
                    </div>
                </div>
              </div>
              </div>
              <div v-show="companySettings.isaacIntegration" class="form-group">
                <label>Isaac Driver Number:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Isaac Driver Number"
                  v-model="addUser_Isaac"
                  v-on:focusout="isValid($event, addUser_Isaac, 'isaacNum')"
                />
                <label
                  class="validation-invalid-label"
                  for="basic"
                  v-bind:class="{ hidden: isaacValid }"
                >
                  {{ isaacValidMessage }}
                </label>
              </div>
              <div>
                <div
                  class="form-group "
                  v-if="this.$store.state.companyFiveOfNine === 'Yes'"
                >
                  <label>5 of 9 employee:</label>
                  <div class="d-flex">
                    <el-tooltip
                      content="All employees are set as 5 of 9 employees per the organization settings"
                      placement="bottom"
                    >
                      <el-switch
                        :value="true"
                        active-color="#13ce66"
                        :disabled="true"
                      ></el-switch>
                    </el-tooltip>
                  </div>
                </div>
                <div v-else class="form-group d-flex flex-column">
                  <label>5 of 9 employee:</label>
                  <el-switch
                    style="display: block"
                    v-model="addUserFiveOfNine"
                    active-color="#13ce66"
                    inactive-color="#ad466c"
                    :active-value="true"
                  ></el-switch>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-link"
                data-dismiss="modal"
                v-on:click="closeModal()"
              >
                Close
              </button>
              <button
                type="button"
                class="btn bg-primary loaderButton"
                v-on:click="submitAddUser()"
              >
                <spring-spinner
                  :animation-duration="3000"
                  :size="15"
                  color="white"
                  v-if="addUser_loading"
                />
                <div v-else>Add User</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </modal-wrapper>
    <!-- /Add User Modal -->
    <AveragingAgreements
      v-if="agreementsLoaded"
      :companySettingsID="companySettingsID"
      :averagingAgreements="averagingAgreements"
      :users="rowData"
      @getAgreements="getAveragingAgreements"
    ></AveragingAgreements>
  </div>
</template>

<script>
import { db, auth } from '../assets/js/firebase/db.js';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { AgGridVue } from 'ag-grid-vue';
import axios from 'axios';

import tableButtons from './childComponents/tableButtons.vue';
import categoryBadges from './childComponents/categoryBadges.vue';
import { SpringSpinner } from 'epic-spinners';
import { MessageBox } from 'element-ui';
import moment from 'moment';

import NotificationSwitcher from '../components/childComponents/notificationSwitcher.vue';
import AveragingAgreements from '../components/averagingAgreements.vue';
import ModalWrapper from '../components/modalWrapper.vue';

export default {
  name: 'manageUsers',
  data() {
    return {
      averagingAgreements: [],
      agreementsLoaded: false,
      agreementOptions: [],
      columnDefs: null,
      rowData: null,
      frameworkComponents: null,
      context: null,
      companySettingsID: null,
      showEditModal: false,
      showAddUserModal: false,
      types: [],
      employeeCategories: [],
      accessLevels: ['admin', 'user'],
      vacationTypes: [],
      editUserName: null,
      editUserEmail: null,
      editUserType: null,
      editUserID: null,
      editUserVacationType: null,
      editUserIsaac: null,
      editUserFiveOfNine: null,
      editUserAccessLevel: null,
      editUserCategory: null,
      editUserAveragingAgreement: null,
      nameValid: true,
      emailValid: true,
      showEditAlert: false,
      showAddUserAlert: false,
      editUserMessage: null,
      addUserMessage: null,
      addUserName: null,
      addUserEmail: null,
      addUserType: null,
      addUser_loading: false,
      addUserVacationType: null,
      addUserFiveOfNine: false,
      addUser_Isaac: null,
      addUserAccessLevel: null,
      addUserCategory: null,
      addUserAveragingAgreement: null,
      userEmailErrorMessage: null,
      companySettings: null,
      isaacValid: true,
      isaacValidMessage: null,
      notificationHoursValid: true,
      notificationHoursMessage: null,
      addUserNotificationHours: null,
      editUserNotificationHours: null,
      addPhoneNumbers: [""],
      editPhoneNumbers: [""],
      phoneNumberValid: true,
      phoneErrors: {},
      originalUserData: [],
      editNotificationEmail: null,
      editNotificationText: null,
    };
  },

  components: {
    AgGridVue,
    SpringSpinner,
    AveragingAgreements,
    ModalWrapper
  },
  beforeMount() {
    this.defaultColDef = {
      cellClass: 'cell-wrap-text',
      autoHeight: true,
      sortable: true,
      resizable: true
    };
    this.defaultRowDef = {
      autoHeight: true
    };
    this.gridOptions = {
      domLayout: 'autoHeight',
    };
    this.gridOptions.getRowStyle = params => {
      if (params.data.status === 'Deactivated') {
        return {
          color: 'gray',
          background: '#353f53',
          borderTop: '1px solid rgba(255,255,255,.1)'
        };
      } else {
        return {
          background: '#353f53',
          borderTop: '1px solid rgba(255,255,255,.1)',
          color: '#fff'
        };
      }
    };
    this.gridOptions.getRowClass = params => {
      if (params.data.status === 'Deactivated') {
        return 'row-deactivated';
      }
      return null;
    };
    this.frameworkComponents = {
      tableButtonsRenderer: tableButtons,
      categoryRenderer: categoryBadges,
      notificationSwitcher: NotificationSwitcher
    };
    this.rowData = [];

    this.context = { componentParent: this };

    //get the user types
    db.collection('userTypes')
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.types.push({
            name: doc.data().name
          });
        });
      })
      .catch(err => {
        console.log(`Error getting user types: ${err}`);
        this.showError('Error getting user types');
      });

    //get the vacation types
    db.collection('vacationTypes')
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.vacationTypes.push({
            name: doc.data().name
          });
        });
      })
      .catch(err => {
        console.log(`Error getting user types: ${err}`);
        this.showError('Error getting user types');
      });

    //get the employee categories
    db.collection('employeeCategories')
      .where('org', '==', this.$store.state.userCompany)
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.employeeCategories.push({
            name: doc.data().name
          });
        });
      })
      .catch(err => {
        console.log(`Error getting employee categories: ${err}`);
        this.showError('Error getting employee categories');
      });

    db.collection('companySettings')
      .where('company', '==', this.$store.state.userCompany)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.companySettingsID = doc.id;
          this.companySettings = {
            isaacIntegration: doc.data().isaacIntegration,
            allowNotifications: doc.data().allowNotifications,
          };

          this.getUsers();
          this.getAveragingAgreements();
        });
        this.columnDefs = [
          {
            headerName: '',
            field: 'tableButtons',
            cellRenderer: 'tableButtonsRenderer',
            cellRendererParams: params => params,
            minWidth: 130,
            pinned: 'left'
          },
          { headerName: 'Name', field: 'name', pinned: 'left' },
          { headerName: 'Email', field: 'email' },
          { headerName: 'Type', field: 'type' },
          { headerName: 'Vacation', field: 'vacation', width: 120 },
          { headerName: 'Access Level', field: 'accessLevel', width: 120 },
          {
            headerName: 'Averaging Agreement',
            field: 'averagingAgreement.name'
          },
          {
            headerName: 'Employee Category',
            field: 'userCategory',
            cellRenderer: 'categoryRenderer'
          },


          {
            headerName: 'Status',
            field: 'status',
            width: 100
          }
        ];

        if(this.companySettings.allowNotifications === "Yes") {
          this.columnDefs.push(
            {
              headerName: 'Notification Hours',
              field: 'notificationHours',
              width: 150
            },
            {
              headerName: 'Email Notification',
              field: 'notificationEmail',
              cellRenderer: 'notificationSwitcher',
              width: 150
            },
            {
              headerName: 'Text Notification',
              field: 'notificationText',
              cellRenderer: 'notificationSwitcher',
              width: 150
            }
          );
        }

        if (this.companySettings.isaacIntegration === true) {
          this.columnDefs.push({
            headerName: 'Isaac Driver #',
            field: 'isaacDriverNo'
          });
        }
      })
      .catch(err => {
        console.log(`Error getting company settings: ${err}`);
        this.showError('Error getting company settings');
      });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.sizeColumnsToFit();
  },
  methods: {
    editUser: function(passedData, fullData) {
      //this method is called from the editUserButton component.
      //open the modal and populate the fields with the passwed data.
      this.showEditAlert = false;
      this.showEditModal = true;
      this.editUserName = passedData.name;
      this.editUserEmail = passedData.email;
      this.editUserType = {
        name: passedData.type
      };
      this.editUserID = passedData.uid;
      this.editUserVacationType = {
        name: passedData.vacation
      };
      this.editUserIsaac = passedData.isaacDriverNo;
      this.editUserFiveOfNine = passedData.fiveOfNine;
      this.editUserAccessLevel = passedData.accessLevel;
      this.editUserCategory = passedData.userCategory;
      this.editUserAveragingAgreement = fullData.averagingAgreement
        ? fullData.averagingAgreement
        : null;
      this.emailValid = true;
      this.nameValid = true;
      this.phoneNumberValid = true;
      this.editUserNotificationHours = fullData.notificationHours;
      this.editPhoneNumbers = fullData.phoneNumbers && fullData.phoneNumbers.length !== 0 ? [...fullData.phoneNumbers] : [''];
      this.editNotificationText = fullData.notificationText;
      this.editNotificationEmail = fullData.notificationEmail
    },
    resetPassword: function(passedData) {
      MessageBox.confirm(
        `Are you sure you want to reset this user's password?`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        auth
          .sendPasswordResetEmail(passedData.email)
          .then(() => {
            this.showSuccess('Password reset email has been sent.');
          })
          .catch(() => {
            this.showError('Error sending password reset email');
          });
      });
    },
    deleteUser: function(passedData) {
      MessageBox.confirm(
        `Are you sure you want to delete this user?`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        let request = {
          uid: `${passedData.uid}`
        };
        axios
          .get(
            // 'http://127.0.0.1:5022/timecardapp-87874/us-central1/deactivateUser',
            'https://us-central1-timecardapp-87874.cloudfunctions.net/deactivateUser',
            {
              params: {
                request
              }
            }
          )
          .then(response => {
            if (response.status == 200) {
              this.showSuccess('User succesfully deactivated.');

              this.rowData = [];
              //update the user list
              this.getUsers();
            } else {
              this.showError('An unhandled error occurred! 🤔');
            }
          })
          .catch(err => {
            console.log(`Error calling the add user function: ${err}`);
            this.showError('Error calling the add user function');
          });
      });
    },
    closeModal: function() {
      this.showEditModal = false;
      this.showAddUserModal = false;
      this.phoneErrors = {};
    },
    isValid: function(e, value, field) {
      if (field == 'name') {
        if (value == null) {
          this.nameValid = false;
        } else if (value.trim() == '') {
          this.nameValid = false;
        } else {
          this.nameValid = true;
        }
      } else if (field == 'email') {
        var emailRegex = /\S+@\S+\.\S+/;
        if (value == null) {
          this.emailValid = false;
          this.userEmailErrorMessage = 'Field cannot be empty';
        } else if (value.trim() == '') {
          this.emailValid = false;
          this.userEmailErrorMessage = 'Field cannot be empty';
        } else if (!emailRegex.test(value)) {
          this.emailValid = false;
          this.userEmailErrorMessage = 'Email is not in a correct format';
        } else {
          this.emailValid = true;
        }
      } else if (field == 'isaacNum' ) {
        //check if the value is a num
        if (isNaN(value)) {
          this.isaacValid = false;
          this.isaacValidMessage = 'Value must be a number';
        } else {
          this.isaacValid = true;
          this.isaacValidMessage = '';
        }
      }
      else if (field == 'notificationHours' ) {
        //check if the value is a num
        if (isNaN(value)) {
          this.notificationHoursValid = false;
          this.notificationHoursMessage = 'Value must be a number';
        } else {
          this.notificationHoursValid = true;
          this.notificationHoursMessage = '';
        }
      }
    },
    submitUserEdit: function() {
      this.addUser_loading = true;
      let request;
      for(let i = 0; i<this.editPhoneNumbers.length; i++){
        this.validatePhoneNumber('edit', i)
      }
      if (
        this.nameValid == false ||
        this.emailValid == false ||
        this.editUserType == null ||
        this.editUserType.name == null ||
        this.editUserVacationType == null ||
        this.editUserVacationType.name == null ||
        this.isaacValid == false ||
        this.editUserAccessLevel == null ||
        this.notificationHoursValid == false
      ) {
        this.showError('Fields in the form cannot be empty');
        this.addUser_loading = false;
      } else if (Object.keys(this.phoneErrors).length > 0) {
        this.showError('Phone number is not valid');
        this.addUser_loading = false;
      } else {
        if(this.editUserNotificationHours === '0' || this.editUserNotificationHours === '') {
          request = {
            name: `${this.editUserName}`,
            email: `${this.editUserEmail}`,
            type: `${this.editUserType.name}`,
            uid: `${this.editUserID}`,
            vacation: `${this.editUserVacationType.name}`,
            roles: `${this.editUserAccessLevel}`,
            userCategory:
              this.editUserCategory != null ? this.editUserCategory : [],
            fiveOfNine:
              this.editUserFiveOfNine != undefined
                ? this.editUserFiveOfNine
                : false,
            averagingAgreement: this.editUserAveragingAgreement,
            test: null,
            notificationHours: this.editUserNotificationHours,
            phoneNumbers: this.editPhoneNumbers[0] !== '' ? this.editPhoneNumbers : [],
            notificationEmail: false,
            notificationText: false,
          };
        } else {
          request = {
            name: `${this.editUserName}`,
            email: `${this.editUserEmail}`,
            type: `${this.editUserType.name}`,
            uid: `${this.editUserID}`,
            vacation: `${this.editUserVacationType.name}`,
            roles: `${this.editUserAccessLevel}`,
            userCategory:
              this.editUserCategory != null ? this.editUserCategory : [],
            fiveOfNine:
              this.editUserFiveOfNine != undefined
                ? this.editUserFiveOfNine
                : false,
            averagingAgreement: this.editUserAveragingAgreement,
            test: null,
            notificationHours: this.editUserNotificationHours,
            phoneNumbers: this.editPhoneNumbers[0] !== '' ? this.editPhoneNumbers : [],
            notificationEmail: this.editNotificationEmail,
            notificationText: this.editNotificationText,
          };
        }
    
        if (this.companySettings.isaacIntegration == true) {
          request['isaacDriverNo'] = `${this.editUserIsaac}`;
        }

        // axios
        //   .get(
        //     'http://localhost:5000/timecardapp-87874/us-central1/updateUser',
        //     {
              axios
                .get(
                  'https://us-central1-timecardapp-87874.cloudfunctions.net/updateUser',
                  {
              params: {
                request
              }
            }
          )
          .then(response => {
            if (response.status == 200) {
              this.addUser_loading = false;
              this.showSuccess('User successfully updated.');
              this.rowData = [];
              //update the user list
              this.getUsers();
              this.closeModal();
            } else {
              this.addUser_loading = false;
              console.log('An unhandled error occurred! 🤔');
              this.showError('An unhandled error occurred! 🤔');
            }
          })
          .catch(err => {
            this.addUser_loading = false;
            console.log(`Error calling the update user function: ${err}`);
            this.showError('Error calling the update user function');
          });
      }
    },
    addUser: function() {
      //clear modal
      this.showAddUserModal = true;
      this.emailValid = true;
      this.nameValid = true;
      this.addUserName = null;
      this.addUserEmail = null;
      this.addUserAccessLevel = null;
      this.addUserVacationType = null;
      this.addUserFiveOfNine = false;
      this.addUserType = null;
      this.addUserCategory = null;
      this.addUserAveragingAgreement = null;
      this.addUserNotificationHours = null;
      this.addPhoneNumbers = [''];
    },
    submitAddUser: function() {
      this.addUser_loading = true;
      for(let i = 0; i < this.addPhoneNumbers.length; i++){
        this.validatePhoneNumber('add', i)
      }
      if (
        this.nameValid == false ||
        this.emailValid == false ||
        this.addUserType == null ||
        this.isaacValid == false ||
        this.addUserVacationType == null ||
        this.addUserAccessLevel == null ||
        this.notificationHoursValid == false
      ) {
        this.addUser_loading = false;
        this.showError('Error adding user; some fields are empty.');
      } else if (Object.keys(this.phoneErrors).length > 0) {
        this.showError('Phone number is not valid');
        this.addUser_loading = false;
      } else {
        let request;
        if (this.companySettings.isaacIntegration == true) {
          request = {
            name: `${this.addUserName}`,
            email: `${this.addUserEmail}`,
            type: `${this.addUserType.name}`,
            isaacDriverNo: `${this.addUser_Isaac}`,
            company: `${this.$store.state.userCompany}`,
            vacation: `${this.addUserVacationType.name}`,
            fiveOfNine: this.addUserFiveOfNine,
            accessLevel: `${this.addUserAccessLevel}`,
            userCategory:
              this.addUserCategory != null ? this.addUserCategory : [],
            averagingAgreement: this.addUserAveragingAgreement,
            notificationHours: this.addUserNotificationHours,
            phoneNumbers: this.addPhoneNumbers[0] !== '' ? this.addPhoneNumbers : []
          };
        } else {
          request = {
            name: `${this.addUserName}`,
            email: `${this.addUserEmail}`,
            type: `${this.addUserType.name}`,
            companySettings: `${this.companySettings}`,
            company: `${this.$store.state.userCompany}`,
            vacation: `${this.addUserVacationType.name}`,
            fiveOfNine: this.addUserFiveOfNine,
            accessLevel: `${this.addUserAccessLevel}`,
            userCategory:
              this.addUserCategory != null ? this.addUserCategory : [],
            averagingAgreement: this.addUserAveragingAgreement,
            notificationHours: this.addUserNotificationHours,
            phoneNumbers: this.addPhoneNumbers[0] !== '' ? this.addPhoneNumbers : []
          };
        }

// axios
//           .get(
//             'http://localhost:5000/timecardapp-87874/us-central1/createUser',
//             {
        axios
          .get(
            'https://us-central1-timecardapp-87874.cloudfunctions.net/createUser',
            {
                            params: {
                request
              }
            }
          )
          .then(response => {
            if (response.status == 200) {
              this.addUser_loading = false;
              this.showSuccess('User successfully created.');
              this.rowData = [];

              //update the user list
              this.getUsers();
              this.closeModal();
            } else {
              this.addUser_loading = false;
              this.showError('An unhandled error occurred! 🤔');
            }
          })
          .catch(err => {
            this.addUser_loading = false;
            console.log(`Error calling the add user function: ${err}`);
            this.showError('Error creating user.');
          });
      }
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    getUsers: function() {
      db.collection('users')
        .where('company', '==', this.$store.state.userCompany)
        .orderBy('name', 'asc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(async doc => {
            let userData = doc.data();
            userData.uid = doc.id;
            this.originalUserData.push(userData);
            if (this.$store.state.showInactiveEmployees == 'Yes') {
              let newUser = {};
              newUser.edit = {
                uid: doc.id,
                email: doc.data().email,
                name: doc.data().name,
                type: doc.data().type,
                vacation: doc.data().vacation,
                fiveOfNine: doc.data().fiveOfNine,
                accessLevel:
                  doc.data().roles != undefined ? doc.data().roles[0] : 'user',
                userCategory:
                  doc.data().userCategory != undefined
                    ? doc.data().userCategory
                    : null,
                notificationHours: doc.data().notificationHours,
                notificationEmail: doc.data().notificationEmail,
                notificationText: doc.data().notificationText,
                phoneNumbers: doc.data().phoneNumbers
              };
              newUser.email = doc.data().email;
              newUser.name = doc.data().name;
              newUser.type = doc.data().type;
              newUser.vacation = doc.data().vacation;
              newUser.fiveOfNine = doc.data().fiveOfNine;
              newUser.averagingAgreement =
                doc.data().averagingAgreement !== undefined
                  ? doc.data().averagingAgreement
                  : null;
              newUser.status = doc.data().deactiveDate
                ? 'Deactivated'
                : 'Active';
              newUser.notificationHours = doc.data().notificationHours;
              newUser.notificationEmail = doc.data().notificationEmail;
              newUser.notificationText = doc.data().notificationText;
              newUser.uid = doc.id;
              newUser.phoneNumbers = doc.data().phoneNumbers;
              if (doc.data().roles != undefined) {
                newUser.accessLevel = doc.data().roles[0];
              }
              if (this.companySettings.isaacIntegration !== undefined) {
                newUser.edit.isaacDriverNo = doc.data().isaacDriverNo;
                newUser.isaacDriverNo = doc.data().isaacDriverNo;
              }
              newUser.userCategory =
                doc.data().userCategory != undefined
                  ? doc.data().userCategory
                  : null;

              this.rowData.push(newUser);
            } else if (
              doc.data().deactiveDate == undefined ||
              doc.data().deactiveDate == null
            ) {
              let newUser = {};
              newUser.edit = {
                uid: doc.id,
                email: doc.data().email,
                name: doc.data().name,
                type: doc.data().type,
                vacation: doc.data().vacation,
                fiveOfNine: doc.data().fiveOfNine,
                accessLevel:
                  doc.data().roles != undefined ? doc.data().roles[0] : 'user',
                userCategory:
                  doc.data().userCategory != undefined
                    ? doc.data().userCategory
                    : null,
                notificationHours: doc.data().notificationHours,
                notificationEmail: doc.data().notificationEmail,
                notificationText: doc.data().notificationText,
                phoneNumbers: doc.data().phoneNumbers
              };
              newUser.email = doc.data().email;
              newUser.name = doc.data().name;
              newUser.type = doc.data().type;
              newUser.vacation = doc.data().vacation;
              newUser.fiveOfNine = doc.data().fiveOfNine;
              newUser.averagingAgreement =
                doc.data().averagingAgreement !== undefined
                  ? doc.data().averagingAgreement
                  : null;
              newUser.status = 'Active';
              newUser.notificationHours = doc.data().notificationHours;
              newUser.notificationEmail = doc.data().notificationEmail;
              newUser.notificationText = doc.data().notificationText;
              newUser.uid = doc.id;
              newUser.phoneNumbers = doc.data().phoneNumbers;

              if (doc.data().roles != undefined) {
                newUser.accessLevel = doc.data().roles[0];
              }
              if (this.companySettings.isaacIntegration !== undefined) {
                newUser.edit.isaacDriverNo = doc.data().isaacDriverNo;
                newUser.isaacDriverNo = doc.data().isaacDriverNo;
              }
              newUser.userCategory =
                doc.data().userCategory != undefined
                  ? doc.data().userCategory
                  : null;

              this.rowData.push(newUser);
            }
          });
        })
        .catch(err => {
          console.log(`Error getting user list: ${err}`);
          this.showError('Error getting user types');
        });
    },
    async getAveragingAgreements() {
      this.averagingAgreements = [];
      this.agreementOptions = [];
      try {
        let averagingAgreementsRef = await db
          .collection(
            `companySettings/${this.companySettingsID}/averagingAgreements`
          )
          .get();
        for (let doc of averagingAgreementsRef.docs) {
          let index = this.averagingAgreements.push(doc.data());
          this.averagingAgreements[index - 1]['docID'] = doc.id;
          this.averagingAgreements[index - 1]['combinedTimeFrame'] = `${
            doc.data().timeFrame
          } ${doc.data().timeFrameUnit}`;
          this.averagingAgreements[index - 1]['displayDate'] = moment(
            doc.data().startDate.toDate()
          ).format('MMM DD, YYYY');

          if (doc.data().deleted !== true) {
            this.agreementOptions.push({
              name: doc.data().name,
              docID: doc.id,
              companySettingsID: this.companySettingsID
            });
          }
        }
        this.agreementsLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
    validateHoursInput() {
      if (this.addUserNotificationHours != null) {
        this.addUserNotificationHours = this.addUserNotificationHours.replace(
          /[^0-9]/g,
          ''
        );
      } else {
        this.addUserNotificationHours = '';
      }

      const numericValue = parseInt(this.addUserNotificationHours);
      if (isNaN(numericValue)) {
        this.addUserNotificationHours = '';
      } else {
        this.addUserNotificationHours = Math.min(
          Math.max(0, numericValue),
          24
        ).toString();
      }
    },
    async disableUserNotification(userId, notification, fieldType) {
      const usersRef = db.collection('users');
      const docRef = usersRef.doc(userId);

      try {
        const docSnapshot = await docRef.get();
        if (!docSnapshot.exists) {
          console.log('No matching documents.');
          return;
        }

        let updateObject = {};
        updateObject[fieldType] = notification;
        await docRef.update(updateObject);

        const notificationType = fieldType.includes('Email') ? 'email' : 'text';

        this.showSuccess(
          `User ${notificationType} notifications have been ${
            notification ? 'enabled' : 'disabled'
          }`
        );
      } catch (error) {
        console.error('Error updating notification email:', error);
        this.showError('Something went wrong');
      }
    },
    addPhoneNumber(type) {
      let phoneNumbers;
      if (type === 'add') {
        phoneNumbers = this.addPhoneNumbers;
      } else if (type === 'edit') {
        phoneNumbers = this.editPhoneNumbers;
      }
      const newNumber = ''; 
      if (!this.isDuplicatePhoneNumber(newNumber, phoneNumbers)) {
        phoneNumbers.push(newNumber);
        // this.validationErrors[phoneNumbers.length - 1] = null;
      } 
    },
    removePhoneNumber(type, index) {
      if (type === 'add') {
        this.addPhoneNumbers.splice(index, 1);
      } else if (type === 'edit') {
        this.editPhoneNumbers.splice(index, 1);
      }
      this.$delete(this.phoneErrors, index);
    },
    validatePhoneNumber: function(type, index) {
      let phoneNumbers;
      let phoneNumber;
      if (type === 'add') {
        phoneNumbers = this.addPhoneNumbers;
      } else if (type === 'edit') {
        phoneNumbers = this.editPhoneNumbers;
      }

      phoneNumber = phoneNumbers[index];
      if (!this.phoneErrors) {
        this.$set(this, 'phoneErrors', {});
      }
      if(phoneNumbers.length === 1 && phoneNumbers[0] === ''){
        this.$delete(this.phoneErrors, index);
        return;
      }
      else if (phoneNumber && phoneNumber.length !== 10 || phoneNumber === "") {
        this.$set(this.phoneErrors, index, 'Phone number must be exactly 10 digits long.');
      } else if (this.isDuplicatePhoneNumber(phoneNumber, phoneNumbers, index)) {
        this.$set(this.phoneErrors, index, 'This phone number already exists.');
      } else {
        this.$delete(this.phoneErrors, index);
      }
    },
    isDuplicatePhoneNumber(number, phoneNumbers, currentIndex) {
      return phoneNumbers.some((phone, index) => phone === number && index !== currentIndex);
    },

    // to do: only for testing - remove after
    // testNotification: function() {
    //   let request = {
    //     key: "test"
    //    };
    //     axios
    //       .get(
    //         'http://localhost:5000/timecardapp-87874/us-central1/testNotification',     {
    //           params: {
    //             request: JSON.stringify(request)
    //           }
    //         }
    //       )
    //       .then(response => {
    //         if (response.status == 200) {
    //               console.log("200")
    //        }})
    //       .catch(err => {
    //         console.log(`Error: ${err}`);
          
    //       });
    //   }
  },
  
};
</script>

<style>
.row-deactivated .el-button--primary {
  opacity: 0.5;
}

.phone-number-input {
  display: flex;
}
.phone-input-btn {
  padding: 0.45rem;
}

.ag-body-horizontal-scroll-viewport {
    scrollbar-color: #262d3c #353f53; 
    scrollbar-width: thin; 
}

.ag-horizontal-left-spacer {
  scrollbar-color: #353f53 #353f53;
}

.ag-body-horizontal-scroll {
  background: #353f53;
}

</style>
